import { useContext, useMemo, useState } from 'react'
import '../../style/components/card.css'
import { context } from '../../context/context';
import { InvoiceData } from '../../funcs/invoiceData';
import { switchh } from '../../context/switch';
import useNewId from '../../funcs/hooks/useNewId';
import { useTranslation } from 'react-i18next';

export default function Card(props) {
    const { t } = useTranslation();
    const [quntity,setQuntity] = useState(0);
    const { setCart, setQueueId } = useContext(context);
    const { setEnableAddWeightManully, loadingProcess } = useContext(switchh);

    let newId = useNewId()

    const addInCart = () => {

        setQueueId(newId);
        const collect = InvoiceData(
            newId,
            props.id,
            props.barcode,
            props.title,
            props.price,
            quntity,
            props.type,
            props.discount,
            props.flagInv
        );

        setCart((prev) => [...prev, collect]);
        setQuntity(0);
    };


    const total = useMemo(() => {
        const discountValue = Number(props.discount?.discountValue || 0);

        if (props.discount?.discountType === "percent") {
            return props.price - (props.price * discountValue / 100);
        }

        return props.price - discountValue;
    }, [props.price, props.discount]);

    const HasInv = Number(props.flagInv.length || 0) <= 0;

    return (
        <div className={`card ${props.available <= 0 ? "not-available-product" : ""}`}>
            <div className='flex flex-space-bet flex-align-item-center'>
            {HasInv &&
                <div className='flag'>
                    <p className='error-bg inline'>لا يوجد مخزون</p>
                </div>
            }
            {props.isManual === true && props.type === "weight" &&
            <div className={!HasInv > 0 ? "flag" : 'weight-ch'}>
                <button onClick={() => 
                    setEnableAddWeightManully((prev) => ({
                        ...prev, 
                        status: true,
                        data: props
                    }))
                    
                    }>weight</button>
            </div>
            }
            </div>
            <div className="head">
                <h3>{props.title}</h3>
            </div>
            <h4 className='price'>{total} {props.currency} 
                {Number(props.discount?.discountValue || 0) !== 0 && (
                    <small>
                        <s>{props.price}{props.currency}</s>
                    </small>
                )}
            </h4>
            <div className="input flex flex-space-bet">
                <button onClick={() => setQuntity((prev) => (prev === 0 ? 0 : prev - 1))}>-</button>
                <span>{quntity}</span>
                <button onClick={() => setQuntity((prev) => (prev + 1))}>+</button>
            </div>
            <button onClick={() => addInCart()} disabled={quntity === 0 || loadingProcess} className={`add ${quntity === 0 ? "disable-btn" : ""}`}>{t("action:add")}</button>
        </div>
    )
}